/**
 * Calcula o valor final do boleto considerando valor base, desconto, multa e juros.
 *
 * @param {Object} params
 * @param {number} params.valor_base - Valor original do boleto.
 * @param {number} [params.novo_valor] - Valor substituto, se definido, prevalece.
 * @param {number} [params.novo_desconto] - Valor do desconto a ser subtraído.
 * @param {boolean} [params.aplicar_multa] - Se deve aplicar multa sobre o valor.
 * @param {boolean} [params.aplicar_juros] - Se deve aplicar juros pelo atraso.
 * @param {number} [params.dias_vencido] - Quantidade de dias após o vencimento.
 * @param {number} [params.multa_percentual=2] - Percentual da multa (ex: 2 = 2%).
 * @param {number} [params.juros_percentual=1] - Juros ao mês (ex: 1 = 1% ao mês).
 * @returns {number} Valor final com os acréscimos ou descontos aplicados.
 */
export function calcularValorFinalBoleto({
                                           valor_base,
                                           novo_valor,
                                           novo_desconto = 0,
                                           aplicar_multa = false,
                                           aplicar_juros = false,
                                           dias_vencido = 0,
                                           multa_percentual = 2,
                                           juros_percentual = 1,
                                         }) {
  let valor = novo_valor ?? valor_base;

  // Aplica desconto
  valor -= novo_desconto;

  // Multa fixa (única)
  if (aplicar_multa && dias_vencido > 0) {
    const multa = (valor * multa_percentual) / 100;
    valor += multa;
  }

  // Juros proporcionais aos dias
  if (aplicar_juros && dias_vencido > 0) {
    const juros_dia = juros_percentual / 30;
    const juros_total = (valor * juros_dia * dias_vencido) / 100;
    valor += juros_total;
  }

  return Number(valor.toFixed(2));
}
